<template>
  <div>
    <div @click="trigger">
      <div class="card" style="margin-bottom: unset !important;">
        <div class="card-body p-0 d-flex align-items-center text-center">
          <i class="fa fa-upload bg-primary p-4 font-2xl"><br/><span class="text-white small font-system"> Importar logo / foto </span></i>
        </div>
      </div>
      <input
        @change="onFileInputChanged"
        ref="fileInput"
        style="display: none;"
        type="file"
        accept="image/*"
      />
    </div>
    <div v-if="loading">
      <div class="card" style="width: 242px; height: 122px; margin-bottom: unset !important;">
        <div class="card-body p-0 d-flex align-items-center text-center">
          <spinner id="loadingDiv" v-if="loading"></spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "./Spinner";
import service from "./../service";
import Config from "../config";

export default {
  name: "CustomDropzone",
  props: {
    limit: false
  },
  data: function() {
    return {
      imagePreview: "",
      loading: false,
      showPreview: false
    };
  },
  created: function() {},
  components: {
    Spinner
  },
  methods: {
    onFileInputChanged(event) {
      console.log("filechanged");
      this.uploadFiles(event.target.files);
    },
    uploadAmountError() {
      alert('O limite de uploads é 6. Remova alguns para adicionar novos.');
    },
    trigger() {
      this.$refs.fileInput.click();
    },
    uploadFiles(files) {
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );

      reader.readAsDataURL(files[0]);
      this.loading = true;

      var formData = new FormData();
      formData.append("file", files[0]);

      const baseURL = Config.BASE_API_URL;

      let options = {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      };

      var vm = this;
      //setTimeout(function() {
        fetch(baseURL + "upload-file-ebook-editor", options).then(async function(response) {
          if (response && response.status && response.status === 200) {
            console.log("response");
            console.log(response);
            vm.$emit("uploadComplete", { fileInfo: (await response.json()).fileInfo});
            vm.imagePreview = "";
            vm.loading = false;
          } else {
            vm.loading = false;
            alert("Houve um problema com seu upload :(. Tente novamente mais tarde!");
          }
        });
      //}, 500);
      
    }
  },
  mounted() {
    var self = this;
    window.addEventListener("dragenter", function(e) {});

    window.addEventListener("dragleave", function(e) {
      e.preventDefault();
    });

    window.addEventListener("dragover", function(e) {
      e.preventDefault();
    });

    window.addEventListener("drop", function(e) {
      e.preventDefault();

      var files = e.dataTransfer.files;
      //this.uploadFile(files);
      self.uploadFiles(files);
    });
  }
};
</script>


<style lang='less' scoped>
#loadingDiv {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
}

.font-system{
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
}

.image-wrapper {
  padding: 20px;
  display: -ms-flexbox;
  display: -moz-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  flex-shrink: 0;
  box-pack: center;
  -webkit--moz-box-pack: center;
  -moz-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-align: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  border-bottom: 1px solid #efefef;
  position: relative;
  img {
    width: 120px;
  }
  .pt-iconfont {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 18px;
    color: #777;
    padding: 10px;
  }
}
</style>

